import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import contentBoxMixin from '../../themes/components/ContentBox';

export const StyledContentBox = styled.div`
  ${contentBoxMixin}
`;

const ContentBox = (props) => <StyledContentBox {...props}>{props.children}</StyledContentBox>;

ContentBox.propTypes = {
  /** ContentBox content */
  children: PropTypes.node.isRequired,
  /** ContentBox highlight */
  highlight: PropTypes.string,
  className: PropTypes.string,
};

ContentBox.defaultProps = {
  highlight: 'gray',
};

/** @component */
export default ContentBox;
